import { render, staticRenderFns } from "./SliderInput.vue?vue&type=template&id=247a2149&"
import script from "./SliderInput.vue?vue&type=script&lang=ts&"
export * from "./SliderInput.vue?vue&type=script&lang=ts&"
import style0 from "./SliderInput.vue?vue&type=style&index=0&id=247a2149&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports